module.exports = __webpack_public_path__ + "static/media/portfolio02.web.app.058d9578.png";